<template>
  <a-modal
    :title="title"
    :width="600"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    :okText="this.$store.getters.language['common.okButton']"
    @cancel="handleCancel"
    :cancelText="this.$store.getters.language['common.closeButton']"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="model" :rules="validatorRules">
        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['application']">
<!--          <a-input placeholder="请输入字典名称" v-model="model.applicationCode"/>-->
          <a-select
            style="width: 100%"
            allowClear
            :disabled="$store.getters.application.applicationType!='platform'"
            v-model="model.applicationCode"
          >
            <a-select-option v-for="(item,index) in allApplications" :key="index.toString()" :value="item.applicationCode">
              {{ item.applicationNameLanguage }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="dictName"
          required
          :label="language['sys.dictfunc.dictName']">
          <a-input :placeholder="language['common.pleaseInput']+language['sys.dictfunc.dictName']"  v-model="model.dictName"/>
        </a-form-model-item>

        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          prop="dictCode"
          required
          :label="language['sys.dictfunc.dictCode']" >
          <a-input :placeholder="language['common.pleaseInput']+language['sys.dictfunc.dictCode']" v-model="model.dictCode"/>
        </a-form-model-item>

        <a-form-model-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['common.desc']" >
          <a-input v-model="model.description"/>
        </a-form-model-item>

      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
  import { get, pick } from 'lodash';
  import { addDict, editDict, duplicateCheck } from '@/api/api'
  import { getAction, deleteAction, putAction, postAction, httpAction } from '@/api/manage'

  export default {
    name: 'DictModal',
    data() {
      return {
        allApplications:[],
        value: 1,
        title: '操作',
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        confirmLoading: false,
      }
    },
    created() {
      this.getSysBmApplication();
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      validatorRules() {
        if (this.language) {
          return {
            dictName: [{ required: true, message: this.language['common.pleaseInput']+this.language['sys.dictfunc.dictName']+'!'}],
            dictCode: [
              { required: true, message: this.language['common.pleaseInput']+this.language['sys.dictfunc.dictCode']+'!' },
              { validator: this.validateDictCode }]

          }
        }
      },
    },
    methods: {
      getSysBmApplication(){
        //getAction("/sys/sysBmApplication/queryList").then((res) => {
        httpAction("/sys/role/getSysBmApplicationDL", "", "get").then((res) => {
          if (res.success) {
            this.allApplications = res.result;
          }
        })
      },
      validateDictCode(rule, value, callback) {
        // 重复校验
        var params = {
          tableName: 'sys_dict',
          fieldName: 'dict_code',
          fieldVal: value,
          dataId: this.model.id
        }
        duplicateCheck(params).then((res) => {
          if (res.success) {
            callback()
          } else {
            callback(res.message)
          }
        })
      },
      handleChange(value) {
        this.model.status = value
      },
      add() {
        if(this.$store.getters.application.applicationType!='platform'){
          this.edit({applicationCode:this.$store.getters.application.applicationCode})
        }else{
          this.edit({})
        }
      },
      edit(record) {
        if (record.id) {
          this.visiblekey = true
        } else {
          this.visiblekey = false
        }
        this.model = Object.assign({}, record)
        this.visible = true
      },
      // 确定
      handleOk() {
        const that = this
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true
            this.model.dictName = (this.model.dictName || '').trim()
            this.model.dictCode = (this.model.dictCode || '').trim()
            this.model.description = (this.model.description || '').trim()
            let obj
            if (!this.model.id) {
              obj = addDict(this.model)
            } else {
              obj = editDict(this.model)
            }
            obj.then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            }).finally(() => {
              that.confirmLoading = false
              that.close()
            })
          }else{
            return false;
          }
        })
      },
      // 关闭
      handleCancel() {
        this.close()
      },
      close() {
        this.$emit('close')
        this.visible = false
        this.$refs.form.resetFields();
      }
    }
  }
</script>